module.exports = __webpack_public_path__ + "img/cover.056db650.png";